//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

    /**
     * Angular wrapper around isotope grids. See http://isotope.metafizzy.co/ for details regarding isotope.
     */
  curalate.directive('isotopeContainer', [
    '$rootScope',
    '$timeout',
    '$parse',
    function(
            $rootScope,
            $timeout,
            $parse,
        ) {
      return {
        restrict: 'AC',
        controller: ['$scope', function($scope) {
          this.addElement = function(element) {
            if ($scope.isotopeContainer) {
              $scope.$applyAsync(() => {
                $scope.isotopeContainer.isotope('addItems', element);
              });
            }
          };

          this.prependElement = function(element) {
            if ($scope.isotopeContainer) {
              $scope.$applyAsync(() => {
                $scope.isotopeContainer.isotope('prepended', element);
              });
            }
          };

          this.removeElement = function(element) {
            if ($scope.isotopeContainer) {
              $scope.isotopeContainer.isotope('remove', element);
            }
          };

          this.refreshIso = function() {
            $scope.refreshIso();
          };
        }],
        link(scope, element, attrs) {
          const isoOptions = $parse(attrs.isoOptions)(scope);
          const imageLoadOptions = $parse(attrs.isoImageLoadOptions)(scope);

          const init = function() {
            delete scope.isotopeContainer;
            scope.isotopeContainer = angular.element(element);
            scope.isotopeContainer.isotope();
            return $timeout(() => {
              scope.isotopeContainer.isotope(isoOptions);
            }, 0);
          };

          scope.refreshIso = function() {
            const refresh = function() {
              const iso = scope.isotopeContainer.isotope();
              scope.$emit('iso-refreshed', iso.isotope('getItemElements'));
            };

            if (scope.isotopeContainer) {
                            // If we have imageLoadOptions, don't layout isotope grid until images are loaded
              if (imageLoadOptions) {
                scope.isotopeContainer.imagesLoaded().progress((instance, image) => {
                                    // As we load each image, swap out the failed images for a fallback
                  if (!image.isLoaded && !!imageLoadOptions.fallback) {
                    image.img.src = imageLoadOptions.fallback;
                  }
                }).fail(() => {
                                    // If any images have failed, re-trigger the imagesLoaded function
                                    // which should now try to load the empty image fallback
                  scope.isotopeContainer.imagesLoaded(() => {
                    refresh();
                  });
                }).done(() => {
                                    // If all images load successfully, refresh immediately.
                  refresh();
                });
              } else {
                refresh();
              }
            }
          };

          scope.$on('iso-refresh', () => {
            scope.refreshIso();
          });

          scope.$on('iso-options', (e, newOptions) => {
            if (scope.isotopeContainer) {
              scope.isotopeContainer.isotope(newOptions);
            }
          });

                    // Note: to add more isotope methods see http://isotope.metafizzy.co/methods.html for reference
          scope.$on('iso-layout', () => {
            if (scope.isotopeContainer) {
              scope.isotopeContainer.isotope('layout');
            }
          });

          init();
        },
      };
    },
  ]);

  curalate.directive('isotopeItem', [
    '$timeout',
    '$parse',
    function(
            $timeout,
            $parse,
        ) {
      return {
        restrict: 'AC',
        require: '^isotopeContainer',
        link(scope, element, attrs, isoCtrl) {
          const isoRefreshItem = $parse(attrs.isoRefreshItem)(scope);

          if (attrs.isotopePrepend) {
            isoCtrl.prependElement(element);
          } else {
            isoCtrl.addElement(element);
          }

          if ((attrs.ngRepeat && scope.$last) || isoRefreshItem) {
            element.ready(() => {
              $timeout(() => {
                isoCtrl.refreshIso();
              }, 0);
            });
          }
        },
      };
    },
  ]);
})();
